var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10001 4H19.1C19.7 4 20.1 4.4 20.1 5V19C20.1 19.6 19.7 20 19.1 20H5.10001C4.50001 20 4.10001 19.6 4.10001 19V5C4.10001 4.4 4.50001 4 5.10001 4Z",
    fill: "#B2B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 14V5C22.1 3.3 20.8 2 19.1 2H5.10001C3.40001 2 2.10001 3.3 2.10001 5V19C2.10001 20.7 3.40001 22 5.10001 22H19.1C20.8 22 22.1 20.7 22.1 19V14ZM5.10001 4H19.1C19.7 4 20.1 4.4 20.1 5V13H17.6C16.9 13 16.3 13.3 15.9 13.9L14.5 16H9.60001L8.20001 13.9C7.80001 13.3 7.20001 13 6.50001 13H4.10001V5C4.10001 4.4 4.50001 4 5.10001 4Z",
    fill: "#5D87FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbox);
export default __webpack_public_path__ + "static/media/icon-inbox.7ef6d8af4f6bb93f52cdb4656a2a00ea.svg";
export { ForwardRef as ReactComponent };